import { useState, useCallback } from 'react';

/**
 * Hook to manage search text state
 * 
 * @returns {Object} - Object containing search text and functions to manage it
 */
const useSearchText = () => {
  const [searchText, setSearchText] = useState('');

  // Function to update search text
  const updateSearchText = useCallback((text) => {
    setSearchText(text);
  }, []);

  // Function to clear search text
  const clearSearchText = useCallback(() => {
    setSearchText('');
  }, []);

  return {
    searchText,
    updateSearchText,
    clearSearchText,
    hasSearchText: searchText.length > 0
  };
};

export default useSearchText;